module.exports = __webpack_public_path__ + "img/loading-icon.1184dd95.svg";